import React from 'react';
import { GiftIcon, CheckIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../utils/constants';
export function BonusSection() {
  const openCheckout = () => {
    window.open(CHECKOUT_URL, '_blank');
  };
  const bonuses = [{
    title: '50 Giochi Veloci per Educazione Fisica',
    description: "Attività rapide da 5 minuti perfette per attivare la classe all'inizio della lezione.",
    value: '€7,99'
  }, {
    title: '30 Lezioni Complete di Educazione Fisica',
    description: 'Programmazione già pronta da utilizzare immediatamente, senza dover pensare a nulla.',
    value: '€9,99'
  }, {
    title: 'Schede di Valutazione Pronte da Stampare',
    description: 'Modelli semplici e chiari per monitorare i progressi degli studenti in modo oggettivo.',
    value: '€5,99'
  }, {
    title: '40 Percorsi Motori Creativi',
    description: 'Percorsi dinamici per sviluppare coordinazione, equilibrio e agilità in modo divertente.',
    value: '€7,99'
  }];
  return <section className="py-20 px-4 bg-blue-800 text-white" data-id="element-27">
      <div className="max-w-5xl mx-auto" data-id="element-28">
        <div className="text-center mb-16" data-id="element-29">
          <div className="inline-flex items-center justify-center p-4 bg-yellow-400 rounded-full mb-6 shadow-lg shadow-yellow-400/30" data-id="element-30">
            <GiftIcon className="w-10 h-10 text-blue-900" data-id="element-31" />
          </div>
          <h2 className="text-3xl md:text-5xl font-bold mb-6" data-id="element-32">
            Ma non è tutto. Se accedi oggi riceverai anche{' '}
            <span className="text-yellow-400" data-id="element-33">4 BONUS EXTRA</span>
          </h2>
          <p className="text-xl text-blue-100 max-w-3xl mx-auto" data-id="element-34">
            In totale riceverai 9 risorse complete per l'insegnamento
            dell'educazione fisica. Un vero sistema che ti aiuterà a organizzare
            le lezioni in modo molto più semplice.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-12" data-id="element-35">
          {bonuses.map((bonus, index) => <div key={index} className="bg-blue-900/80 border border-blue-600 rounded-2xl p-6 md:p-8 flex flex-col relative overflow-hidden shadow-xl" data-id="element-36">
              <div className="absolute top-0 right-0 bg-red-500 text-white font-bold text-sm px-4 py-1.5 rounded-bl-lg shadow-md" data-id="element-37">
                GRATIS OGGI
              </div>

              <div className="text-yellow-400 font-bold text-xl mb-2" data-id="element-38">
                BONUS {index + 1}
              </div>

              <h3 className="text-2xl font-bold mb-3 text-white" data-id="element-39">
                {bonus.title}
              </h3>
              <p className="text-blue-200 mb-6 leading-relaxed flex-1" data-id="element-40">
                {bonus.description}
              </p>

              <div className="pt-4 border-t border-blue-700/50 flex items-center justify-between" data-id="element-41">
                <span className="text-blue-300 text-sm" data-id="element-42">
                  Valore: <span className="line-through" data-id="element-43">{bonus.value}</span>
                </span>
                <span className="text-green-400 font-bold uppercase" data-id="element-44">
                  Incluso Gratis
                </span>
              </div>
            </div>)}
        </div>

        <div className="text-center" data-id="element-45">
          <button onClick={openCheckout} className="inline-block bg-green-500 hover:bg-green-400 text-white font-bold text-xl py-4 px-12 rounded-full shadow-[0_8px_30px_rgb(34,197,94,0.3)] transform hover:-translate-y-1 transition-all duration-300 border-b-4 border-green-700" data-id="element-46">
            VOGLIO IL PACK + I BONUS GRATIS
          </button>
        </div>
      </div>
    </section>;
}